import { render, staticRenderFns } from "./setting_device.vue?vue&type=template&id=044627f2&scoped=true"
import script from "./setting_device.vue?vue&type=script&lang=js"
export * from "./setting_device.vue?vue&type=script&lang=js"
import style0 from "./setting_device.vue?vue&type=style&index=0&id=044627f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044627f2",
  null
  
)

export default component.exports